export const etsy = {
  oAuthFlowHelp: "Meinen Etsy Shop autorisieren",
  authSuccess: "Die Autorisierung bei Etsy war erfolgreich."
};
